import CommonTextEditor from "components/common/CommonTextEditor";
import { useProjectFormContext } from "pages/project/context/ProjectFormContext";

function FormField({ label, error, children }) {
  return (
    <div className="flex flex-col gap-1">
      <label className="text-xs font-semibold text-text-500">{label}</label>
      {children}
      {error && (
        <p className="text-xs font-medium text-red-600" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}

const inputClass = (hasError) =>
  [
    "w-full rounded-lg border px-3 py-2 text-sm text-text-900 placeholder:text-text-400 outline-none transition",
    "focus:ring-2 focus:ring-brand-200 focus:border-brand-400",
    hasError
      ? "border-red-400 ring-1 ring-red-200 bg-red-50/30"
      : "border-slate-200 bg-white shadow-sm hover:border-slate-300",
  ].join(" ");

export default function StepCompanyOverview() {
  const { values, setField, errors } = useProjectFormContext();

  return (
    <div className="space-y-6 transition-opacity duration-300">
      <div className="grid gap-4 sm:grid-cols-2">
        <FormField label="Company Website" error={errors.companyWebsite}>
          <input
            type="url"
            value={values.companyWebsite}
            onChange={(e) => setField("companyWebsite", e.target.value)}
            placeholder="https://yourcompany.com"
            className={inputClass(errors.companyWebsite)}
          />
        </FormField>

        <FormField label="Company Email Address" error={errors.companyEmail}>
          <input
            type="email"
            value={values.companyEmail}
            onChange={(e) => setField("companyEmail", e.target.value)}
            placeholder="e.g. info@yourcompany.com"
            className={inputClass(errors.companyEmail)}
          />
        </FormField>

        <FormField label="Company Phone No" error={errors.companyPhone}>
          <input
            type="tel"
            value={values.companyPhone}
            onChange={(e) => setField("companyPhone", e.target.value)}
            placeholder="e.g. 647-368-7789"
            className={inputClass(errors.companyPhone)}
          />
        </FormField>

        <FormField label="Head Office Address" error={errors.companyHeadOfficeAddress}>
          <input
            type="text"
            value={values.companyHeadOfficeAddress}
            onChange={(e) => setField("companyHeadOfficeAddress", e.target.value)}
            placeholder="e.g. 1194 Bloor St W, Toronto, ON"
            className={inputClass(errors.companyHeadOfficeAddress)}
          />
        </FormField>
      </div>

      <fieldset className="min-w-0 border-0 p-0">
        <legend className="mb-2 block w-full px-0 text-xs font-semibold text-text-500">
          Company overview
        </legend>
        <div
          className={[
            "overflow-hidden rounded-xl border bg-white",
            errors.companyOverview ? "border-red-400 ring-1 ring-red-200" : "border-slate-200 shadow-card",
          ].join(" ")}
        >
          <CommonTextEditor
            value={values.companyOverview}
            onChange={(html) => setField("companyOverview", html)}
            placeholder="Summarize leadership, traction, and market position…"
            height={240}
            error={errors.companyOverview}
          />
        </div>
        {errors.companyOverview && (
          <p className="mt-1 text-xs font-medium text-red-600" role="alert">
            {errors.companyOverview}
          </p>
        )}
      </fieldset>
    </div>
  );
}
